/**
 * np-product-card.js
 *
 * Image switching:
 *   mouseenter on .product-card → add .product-card--image-hover (if 2nd image exists)
 *   mouseleave on .product-card → remove .product-card--image-hover
 *
 * Badge hover:
 *   mouseenter on .badge → add .badge--active
 *   mouseleave on .badge → remove .badge--active
 */

function markLastRowCards(root) {
  var scope = root || document;
  scope.querySelectorAll('.product-grid').forEach(function (grid) {
    var cards = Array.from(grid.querySelectorAll('.product-card'));
    if (!cards.length) return;

    cards.forEach(function (c) { c.classList.remove('is-last-row'); });

    var maxBottom = Math.max.apply(null, cards.map(function (c) {
      return c.getBoundingClientRect().bottom;
    }));

    cards.forEach(function (c) {
      if (Math.abs(c.getBoundingClientRect().bottom - maxBottom) < 2) {
        c.classList.add('is-last-row');
      }
    });
  });
}

function initProductCards(root) {
  var scope = root || document;

  markLastRowCards(root);

  // Image switching — card level
  scope.querySelectorAll('.product-card').forEach(function (card) {
    if (!card.querySelector('.product-card__img--hover')) return;

    card.addEventListener('mouseenter', function () {
      card.classList.add('product-card--image-hover');
    });

    card.addEventListener('mouseleave', function () {
      card.classList.remove('product-card--image-hover');
    });
  });

  // Badge hover — badge level
  scope.querySelectorAll('.badge').forEach(function (badge) {
    badge.addEventListener('mouseenter', function () {
      badge.classList.add('badge--active');
    });

    badge.addEventListener('mouseleave', function () {
      badge.classList.remove('badge--active');
    });
  });
}

// Initial load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { initProductCards(); });
} else {
  initProductCards();
}

// Resize: re-mark last row (debounced)
var _markLastRowTimer;
window.addEventListener('resize', function () {
  clearTimeout(_markLastRowTimer);
  _markLastRowTimer = setTimeout(function () { markLastRowCards(); }, 150);
});

// Shopify customizer: re-init when a section reloads or settings change
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    initProductCards(event.target);
  });
  document.addEventListener('shopify:section:select', function () {
    markLastRowCards();
  });
}
